import { ReactComponent as CalendarSvg } from '../../assets/icons/calendar.svg';

export const CalendarIcon: SvgIcon = (props) => {
    return <CalendarSvg {...props} />;
};
